<template>
    <v-text-field
        clearable
        @keyup.enter="handleFilter"
        @click:clear="handleClearFilter"
        v-model="filter"
        v-bind="$attrs"
    >
        <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData"><slot :name="name" v-bind="slotData" /></template>
    </v-text-field>
</template>

<script>
export default {
    name: 'core-table-filter',
    props: {
        queryParam: {
            type: String,
            default: "q"
        },
    },
    data: function() {
        return {
            filter: ""
        };
    },
    methods: {
        applyRouteOptionsCode(optionsCode) {
            if(this.getRouteOptionsCode() == optionsCode) {
                console.log('código igual');
                return;
            }

            this.$router.replace({
                query: {
                    ...this.$route.query,
                    [this.queryParam]: optionsCode
                }
            })
        },
        createOptionsCode(options) {
            const { page, itemsPerPage, sortBy, sortDesc, filter } = options;

            return btoa(JSON.stringify({
                page, 
                itemsPerPage, 
                sortBy, 
                sortDesc,
                filter
            }));
        },
        handleFilter() {
            this.applyRouteOptionsCode(
                this.createOptionsCode({
                    ...this.queryToOptions(),
                    filter: this.filter,
                    page: 1
            }));
        },
        handleClearFilter() {
            this.filter = "";
            this.applyRouteOptionsCode(
                this.createOptionsCode({
                    ...this.queryToOptions(),
                    filter: "",
                    page: 1
            }));
        },
        queryToOptions() {
            const code = this.getRouteOptionsCode();           
            const jsonData = atob(code);

            try {
                const data = JSON.parse(jsonData);
                
                return {
                    ...data
                };
            } catch(error) {
                return;
            }
        },
        getQueryFilter() {
            const code = this.getRouteOptionsCode();
            if(!code) 
                return "";
            
            const jsonData = atob(code);

            try {
                const data = JSON.parse(jsonData);
                
                return data.filter || "";
            } catch(error) {
                return "";
            }
        },
        getRouteOptionsCode() {
            return this.$route.query[this.queryParam];
        },
    },
    created() {
        this.filter = this.getQueryFilter();
    }
}
</script>